import { mapState } from "pinia";
import { LayoutTypes } from "@/services/context/layout-helper";
import { useContextStore } from '@/store/context'
import { useGtm } from '@gtm-support/vue-gtm';

export const useProductDetailsTracking = () => {
  const gtm = useGtm();
  const contextStore = useContextStore();

  const { layout: layoutType } = storeToRefs(contextStore);

  const trackProductPage = (payload) => {
    const finalProducts = []
    const list = payload.actionField === "DP" ? payload.products[0].attributes.category_path
      ? payload.products[0].attributes.category_path.substr(payload.products[0].attributes.category_path.lastIndexOf('/') + 2) : payload.actionField
      : payload.actionField
    const pushObject = {
      event: payload.type,
      categoryGA: trackingCodes.CATEGORYGA.ecommerce,
      actionGA: payload.type === trackingCodes.IMPRESSIONDONE ? trackingCodes.PRODUCTIMPRESSION : payload.type,
      labelGA: payload.type === trackingCodes.IMPRESSIONDONE ? trackingCodes.PRODUCTIMPRESSION : payload.type,
      nonInteraction: payload.type === trackingCodes.DETAILVIEW || payload.type === trackingCodes.IMPRESSIONDONE,
      sitetype: layoutType.value === LayoutTypes.default ? 'd' : 'm',
      ecommerce: {}
    }

    for (let i = 0; i < payload.products.length; i++) {
      const attributes = payload.products[i].attributes;
      const product = {
        name: attributes.designation,
        id: payload.products[i].id,
        price: attributes.prix,
        category: attributes.category_path,
        dimension10: "",
        dimension11: "",
        dimension13: "",
        dimension12: "",
        metric3: "",
        metric4: "",
        metric5: ""

      }
      if (attributes.is_variant && attributes.variant_axes) {
        product.variant = `${attributes.variant_axes.axe_one.value} | ${attributes.variant_axes.axe_two.value}`
      }

      if (attributes.marque) {
        product.brand = attributes.marque
      }
      if (attributes.review_rate) {
        product.dimension10 = attributes.review_rate
        product.dimension13 = attributes.reviews_count
      }
      if (attributes.discount_amount) {
        product.metric5 = attributes.discount_amount
      }
      if (attributes.pft === 1 && attributes.pft_conf) {
        product.metric5 = attributes.pft_conf.PLAGE[0].REDUC
      }
      switch (payload.type) {
        case trackingCodes.PRODUCTCLICK:
          product.position = payload.index;
          break;
        case trackingCodes.DETAILVIEW:
          product.dimension12 = attributes.photos ? attributes.photos.length : 0;
          product.metric3 = attributes.taux_tva;
          product.metric4 = attributes.prix_ht;
          break;
        case trackingCodes.IMPRESSIONDONE:
          product.position = parseInt(payload.index) - 5 + i;
          product.list = list
          break;
      }
      finalProducts.push(product)
    }
    switch (payload.type) {
      case trackingCodes.PRODUCTCLICK:
        pushObject.ecommerce.click = {
          actionField: { list },
          products: finalProducts
        }
        break;
      case trackingCodes.IMPRESSIONDONE:
        pushObject.ecommerce.currencyCode = trackingCodes.CURRENCYCODE
        pushObject.ecommerce.impressions = finalProducts
        break;
      case trackingCodes.DETAILVIEW:
        pushObject.ecommerce.detail = {
          products: finalProducts
        }
        break;
    }
    try {
      gtm.trackEvent(pushObject)
    } catch {
      console.log("ERROR! something went wrong (product page)")
    }
  }

  return { trackProductPage }
}
